import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { InventoryService } from '../../services/inventory.service';

@Component({
  selector: 'app-inventory-repair-queue',
  templateUrl: './inventory-repair-queue.component.html',
  styleUrls: ['./inventory-repair-queue.component.scss']
})
export class InventoryRepairQueueComponent implements OnInit {

  public isLoaded = false;

  public dataSourcRepairs: MatTableDataSource<InventoryItem>;
  public columnsToDisplay1 = [
    'code',
    'title'
  ];

  constructor(
    private inventoryService: InventoryService,
    private cdr: ChangeDetectorRef,
    private router: Router) { }

  ngOnInit(): void {
    this.inventoryService.find({decision: "Repair"}, "number", "asc").subscribe((items: InventoryItem[]) => {
      this.dataSourcRepairs = new MatTableDataSource<InventoryItem>(items);
      this.cdr.detectChanges();
      this.isLoaded = true;
    });
  }

  viewItem(number: number) {
    this.router.navigate(["inventory", "view-item", number])
  }
}
